import mergedTheme from './baseTheme'

const baseTheme = mergedTheme
export { baseTheme }
